package com.eladfinish.bible.contest

import dev.icerock.moko.graphics.Color
import dev.icerock.moko.resources.ColorResource
import kotlin.collections.List

internal object CommonMainColors0 {
  internal val action_bar_divider: ColorResource by lazy { init_action_bar_divider() }

  internal val alternateColorListView: ColorResource by lazy { init_alternateColorListView() }

  internal val background_dialog_fragment: ColorResource by lazy { init_background_dialog_fragment()
      }

  internal val bg_drag_handle: ColorResource by lazy { init_bg_drag_handle() }

  internal val bg_item_dragging_active_state: ColorResource by lazy {
      init_bg_item_dragging_active_state() }

  internal val bg_item_dragging_state: ColorResource by lazy { init_bg_item_dragging_state() }

  internal val bg_item_normal_state: ColorResource by lazy { init_bg_item_normal_state() }

  internal val bg_item_swiping_active_state: ColorResource by lazy {
      init_bg_item_swiping_active_state() }

  internal val bg_item_swiping_state: ColorResource by lazy { init_bg_item_swiping_state() }

  internal val bg_swipe_item_neutral: ColorResource by lazy { init_bg_swipe_item_neutral() }

  internal val bg_swipe_item_pinned: ColorResource by lazy { init_bg_swipe_item_pinned() }

  internal val black: ColorResource by lazy { init_black() }

  internal val blue2: ColorResource by lazy { init_blue2() }

  internal val blue25: ColorResource by lazy { init_blue25() }

  internal val colorAccent: ColorResource by lazy { init_colorAccent() }

  internal val colorMainbg: ColorResource by lazy { init_colorMainbg() }

  internal val colorPrimary: ColorResource by lazy { init_colorPrimary() }

  internal val colorPrimaryDark: ColorResource by lazy { init_colorPrimaryDark() }

  internal val colorPrimaryLight: ColorResource by lazy { init_colorPrimaryLight() }

  internal val colorPrimaryText: ColorResource by lazy { init_colorPrimaryText() }

  internal val colorSecondaryText: ColorResource by lazy { init_colorSecondaryText() }

  internal val colorText: ColorResource by lazy { init_colorText() }

  internal val darkGreen: ColorResource by lazy { init_darkGreen() }

  internal val darkRed: ColorResource by lazy { init_darkRed() }

  internal val dark_gray: ColorResource by lazy { init_dark_gray() }

  internal val dialogBackground: ColorResource by lazy { init_dialogBackground() }

  internal val dialogTitle: ColorResource by lazy { init_dialogTitle() }

  internal val divider_line_main_feed: ColorResource by lazy { init_divider_line_main_feed() }

  internal val etColor: ColorResource by lazy { init_etColor() }

  internal val grey05: ColorResource by lazy { init_grey05() }

  internal val highlight: ColorResource by lazy { init_highlight() }

  internal val list_item_secondary_text: ColorResource by lazy { init_list_item_secondary_text() }

  internal val menu_background_color: ColorResource by lazy { init_menu_background_color() }

  internal val menu_text_color: ColorResource by lazy { init_menu_text_color() }

  internal val monopoly_fine: ColorResource by lazy { init_monopoly_fine() }

  internal val monopoly_prize: ColorResource by lazy { init_monopoly_prize() }

  internal val monopoly_question: ColorResource by lazy { init_monopoly_question() }

  internal val onqelos: ColorResource by lazy { init_onqelos() }

  internal val orange4: ColorResource by lazy { init_orange4() }

  internal val orange5: ColorResource by lazy { init_orange5() }

  internal val referenceColor: ColorResource by lazy { init_referenceColor() }

  internal val reka: ColorResource by lazy { init_reka() }

  internal val strokeColor: ColorResource by lazy { init_strokeColor() }

  internal val strokeColorMaterial: ColorResource by lazy { init_strokeColorMaterial() }

  internal val themedColor: ColorResource by lazy { init_themedColor() }

  internal val themedReferenceColor: ColorResource by lazy { init_themedReferenceColor() }

  internal val transparent: ColorResource by lazy { init_transparent() }

  internal val transparent_orange4: ColorResource by lazy { init_transparent_orange4() }

  internal val transparent_orange5: ColorResource by lazy { init_transparent_orange5() }

  internal val valueColor: ColorResource by lazy { init_valueColor() }

  internal fun values(): List<ColorResource> = listOf(action_bar_divider, alternateColorListView,
      background_dialog_fragment, bg_drag_handle, bg_item_dragging_active_state,
      bg_item_dragging_state, bg_item_normal_state, bg_item_swiping_active_state,
      bg_item_swiping_state, bg_swipe_item_neutral, bg_swipe_item_pinned, black, blue2, blue25,
      colorAccent, colorMainbg, colorPrimary, colorPrimaryDark, colorPrimaryLight, colorPrimaryText,
      colorSecondaryText, colorText, darkGreen, darkRed, dark_gray, dialogBackground, dialogTitle,
      divider_line_main_feed, etColor, grey05, highlight, list_item_secondary_text,
      menu_background_color, menu_text_color, monopoly_fine, monopoly_prize, monopoly_question,
      onqelos, orange4, orange5, referenceColor, reka, strokeColor, strokeColorMaterial,
      themedColor, themedReferenceColor, transparent, transparent_orange4, transparent_orange5,
      valueColor)
}

private fun init_action_bar_divider(): ColorResource = ColorResource(lightColor = Color(0xff5722ff),
    darkColor = Color(0xff5722ff))

private fun init_alternateColorListView(): ColorResource = ColorResource(lightColor =
    Color(0xefebe9ff), darkColor = Color(0xefebe9ff))

private fun init_background_dialog_fragment(): ColorResource = ColorResource(lightColor =
    Color(0xffffffff), darkColor = Color(0xffffffff))

private fun init_bg_drag_handle(): ColorResource = ColorResource(lightColor = Color(0x20000000),
    darkColor = Color(0x20000000))

private fun init_bg_item_dragging_active_state(): ColorResource = ColorResource(lightColor =
    Color(0xffff9999), darkColor = Color(0xffff9999))

private fun init_bg_item_dragging_state(): ColorResource = ColorResource(lightColor =
    Color(0xffffdddd), darkColor = Color(0xffffdddd))

private fun init_bg_item_normal_state(): ColorResource = ColorResource(lightColor =
    Color(0xfff0f0f0), darkColor = Color(0xfff0f0f0))

private fun init_bg_item_swiping_active_state(): ColorResource = ColorResource(lightColor =
    Color(0xff9999ff), darkColor = Color(0xff9999ff))

private fun init_bg_item_swiping_state(): ColorResource = ColorResource(lightColor =
    Color(0xffddddff), darkColor = Color(0xffddddff))

private fun init_bg_swipe_item_neutral(): ColorResource = ColorResource(lightColor =
    Color(0x00000000), darkColor = Color(0x00000000))

private fun init_bg_swipe_item_pinned(): ColorResource = ColorResource(lightColor =
    Color(0xfff9930d), darkColor = Color(0xfff9930d))

private fun init_black(): ColorResource = ColorResource(lightColor = Color(0x000000ff), darkColor =
    Color(0x000000ff))

private fun init_blue2(): ColorResource = ColorResource(lightColor = Color(0x64b5f6ff), darkColor =
    Color(0x64b5f6ff))

private fun init_blue25(): ColorResource = ColorResource(lightColor = Color(0x2196f3ff), darkColor =
    Color(0x2196f3ff))

private fun init_colorAccent(): ColorResource = ColorResource(lightColor = Color(0xff5722ff),
    darkColor = Color(0xff5722ff))

private fun init_colorMainbg(): ColorResource = ColorResource(lightColor = Color(0x0d283bff),
    darkColor = Color(0x0d283bff))

private fun init_colorPrimary(): ColorResource = ColorResource(lightColor = Color(0x795548ff),
    darkColor = Color(0x795548ff))

private fun init_colorPrimaryDark(): ColorResource = ColorResource(lightColor = Color(0x5d4037ff),
    darkColor = Color(0x5d4037ff))

private fun init_colorPrimaryLight(): ColorResource = ColorResource(lightColor = Color(0xd7ccc8ff),
    darkColor = Color(0xd7ccc8ff))

private fun init_colorPrimaryText(): ColorResource = ColorResource(lightColor = Color(0x212121ff),
    darkColor = Color(0x212121ff))

private fun init_colorSecondaryText(): ColorResource = ColorResource(lightColor = Color(0x727272ff),
    darkColor = Color(0x727272ff))

private fun init_colorText(): ColorResource = ColorResource(lightColor = Color(0xffffffff),
    darkColor = Color(0xffffffff))

private fun init_darkGreen(): ColorResource = ColorResource(lightColor = Color(0x4caf50ff),
    darkColor = Color(0x4caf50ff))

private fun init_darkRed(): ColorResource = ColorResource(lightColor = Color(0xf44336ff), darkColor
    = Color(0xf44336ff))

private fun init_dark_gray(): ColorResource = ColorResource(lightColor = Color(0x777777ff),
    darkColor = Color(0x777777ff))

private fun init_dialogBackground(): ColorResource = ColorResource(lightColor = Color(0xeeeeeeff),
    darkColor = Color(0xeeeeeeff))

private fun init_dialogTitle(): ColorResource = ColorResource(lightColor = Color(0xbbbbbbff),
    darkColor = Color(0xbbbbbbff))

private fun init_divider_line_main_feed(): ColorResource = ColorResource(lightColor =
    Color(0xf5f8faff), darkColor = Color(0xf5f8faff))

private fun init_etColor(): ColorResource = ColorResource(lightColor = Color(0x00000fff), darkColor
    = Color(0x00000fff))

private fun init_grey05(): ColorResource = ColorResource(lightColor = Color(0x311b92ff), darkColor =
    Color(0x311b92ff))

private fun init_highlight(): ColorResource = ColorResource(lightColor = Color(0x1a237eff),
    darkColor = Color(0x1a237eff))

private fun init_list_item_secondary_text(): ColorResource = ColorResource(lightColor =
    Color(0x5c5c5cff), darkColor = Color(0x5c5c5cff))

private fun init_menu_background_color(): ColorResource = ColorResource(lightColor =
    Color(0x3e2723ff), darkColor = Color(0x3e2723ff))

private fun init_menu_text_color(): ColorResource = ColorResource(lightColor = Color(0xfff8e1ff),
    darkColor = Color(0xfff8e1ff))

private fun init_monopoly_fine(): ColorResource = ColorResource(lightColor = Color(0xbf504dff),
    darkColor = Color(0xbf504dff))

private fun init_monopoly_prize(): ColorResource = ColorResource(lightColor = Color(0x4b82bfff),
    darkColor = Color(0x4b82bfff))

private fun init_monopoly_question(): ColorResource = ColorResource(lightColor = Color(0xf59747ff),
    darkColor = Color(0xf59747ff))

private fun init_onqelos(): ColorResource = ColorResource(lightColor = Color(0x1a237eff), darkColor
    = Color(0x1a237eff))

private fun init_orange4(): ColorResource = ColorResource(lightColor = Color(0xffb74dff), darkColor
    = Color(0xffb74dff))

private fun init_orange5(): ColorResource = ColorResource(lightColor = Color(0xff6f00ff), darkColor
    = Color(0xff6f00ff))

private fun init_referenceColor(): ColorResource = ColorResource(lightColor = Color(0xb02743ff),
    darkColor = Color(0xb02743ff))

private fun init_reka(): ColorResource = ColorResource(lightColor = Color(0xff4081ff), darkColor =
    Color(0xff4081ff))

private fun init_strokeColor(): ColorResource = ColorResource(lightColor = Color(0xdaa000ff),
    darkColor = Color(0xdaa000ff))

private fun init_strokeColorMaterial(): ColorResource = ColorResource(lightColor =
    Color(0xffffa000), darkColor = Color(0xffffa000))

private fun init_themedColor(): ColorResource = ColorResource(lightColor = Color(0xb92743ff),
    darkColor = Color(0x7ccfeeff))

private fun init_themedReferenceColor(): ColorResource = ColorResource(lightColor =
    Color(0xb02743ff), darkColor = Color(0xb02743ff))

private fun init_transparent(): ColorResource = ColorResource(lightColor = Color(0x00ffffff),
    darkColor = Color(0x00ffffff))

private fun init_transparent_orange4(): ColorResource = ColorResource(lightColor =
    Color(0x46ffb74d), darkColor = Color(0x46ffb74d))

private fun init_transparent_orange5(): ColorResource = ColorResource(lightColor =
    Color(0x46ff6f00), darkColor = Color(0x46ff6f00))

private fun init_valueColor(): ColorResource = ColorResource(lightColor = Color(0xb02743ff),
    darkColor = Color(0xb02743ff))

public actual val SharedRes.colors.action_bar_divider: ColorResource
  get() = CommonMainColors0.action_bar_divider

public actual val SharedRes.colors.alternateColorListView: ColorResource
  get() = CommonMainColors0.alternateColorListView

public actual val SharedRes.colors.background_dialog_fragment: ColorResource
  get() = CommonMainColors0.background_dialog_fragment

public actual val SharedRes.colors.bg_drag_handle: ColorResource
  get() = CommonMainColors0.bg_drag_handle

public actual val SharedRes.colors.bg_item_dragging_active_state: ColorResource
  get() = CommonMainColors0.bg_item_dragging_active_state

public actual val SharedRes.colors.bg_item_dragging_state: ColorResource
  get() = CommonMainColors0.bg_item_dragging_state

public actual val SharedRes.colors.bg_item_normal_state: ColorResource
  get() = CommonMainColors0.bg_item_normal_state

public actual val SharedRes.colors.bg_item_swiping_active_state: ColorResource
  get() = CommonMainColors0.bg_item_swiping_active_state

public actual val SharedRes.colors.bg_item_swiping_state: ColorResource
  get() = CommonMainColors0.bg_item_swiping_state

public actual val SharedRes.colors.bg_swipe_item_neutral: ColorResource
  get() = CommonMainColors0.bg_swipe_item_neutral

public actual val SharedRes.colors.bg_swipe_item_pinned: ColorResource
  get() = CommonMainColors0.bg_swipe_item_pinned

public actual val SharedRes.colors.black: ColorResource
  get() = CommonMainColors0.black

public actual val SharedRes.colors.blue2: ColorResource
  get() = CommonMainColors0.blue2

public actual val SharedRes.colors.blue25: ColorResource
  get() = CommonMainColors0.blue25

public actual val SharedRes.colors.colorAccent: ColorResource
  get() = CommonMainColors0.colorAccent

public actual val SharedRes.colors.colorMainbg: ColorResource
  get() = CommonMainColors0.colorMainbg

public actual val SharedRes.colors.colorPrimary: ColorResource
  get() = CommonMainColors0.colorPrimary

public actual val SharedRes.colors.colorPrimaryDark: ColorResource
  get() = CommonMainColors0.colorPrimaryDark

public actual val SharedRes.colors.colorPrimaryLight: ColorResource
  get() = CommonMainColors0.colorPrimaryLight

public actual val SharedRes.colors.colorPrimaryText: ColorResource
  get() = CommonMainColors0.colorPrimaryText

public actual val SharedRes.colors.colorSecondaryText: ColorResource
  get() = CommonMainColors0.colorSecondaryText

public actual val SharedRes.colors.colorText: ColorResource
  get() = CommonMainColors0.colorText

public actual val SharedRes.colors.darkGreen: ColorResource
  get() = CommonMainColors0.darkGreen

public actual val SharedRes.colors.darkRed: ColorResource
  get() = CommonMainColors0.darkRed

public actual val SharedRes.colors.dark_gray: ColorResource
  get() = CommonMainColors0.dark_gray

public actual val SharedRes.colors.dialogBackground: ColorResource
  get() = CommonMainColors0.dialogBackground

public actual val SharedRes.colors.dialogTitle: ColorResource
  get() = CommonMainColors0.dialogTitle

public actual val SharedRes.colors.divider_line_main_feed: ColorResource
  get() = CommonMainColors0.divider_line_main_feed

public actual val SharedRes.colors.etColor: ColorResource
  get() = CommonMainColors0.etColor

public actual val SharedRes.colors.grey05: ColorResource
  get() = CommonMainColors0.grey05

public actual val SharedRes.colors.highlight: ColorResource
  get() = CommonMainColors0.highlight

public actual val SharedRes.colors.list_item_secondary_text: ColorResource
  get() = CommonMainColors0.list_item_secondary_text

public actual val SharedRes.colors.menu_background_color: ColorResource
  get() = CommonMainColors0.menu_background_color

public actual val SharedRes.colors.menu_text_color: ColorResource
  get() = CommonMainColors0.menu_text_color

public actual val SharedRes.colors.monopoly_fine: ColorResource
  get() = CommonMainColors0.monopoly_fine

public actual val SharedRes.colors.monopoly_prize: ColorResource
  get() = CommonMainColors0.monopoly_prize

public actual val SharedRes.colors.monopoly_question: ColorResource
  get() = CommonMainColors0.monopoly_question

public actual val SharedRes.colors.onqelos: ColorResource
  get() = CommonMainColors0.onqelos

public actual val SharedRes.colors.orange4: ColorResource
  get() = CommonMainColors0.orange4

public actual val SharedRes.colors.orange5: ColorResource
  get() = CommonMainColors0.orange5

public actual val SharedRes.colors.referenceColor: ColorResource
  get() = CommonMainColors0.referenceColor

public actual val SharedRes.colors.reka: ColorResource
  get() = CommonMainColors0.reka

public actual val SharedRes.colors.strokeColor: ColorResource
  get() = CommonMainColors0.strokeColor

public actual val SharedRes.colors.strokeColorMaterial: ColorResource
  get() = CommonMainColors0.strokeColorMaterial

public actual val SharedRes.colors.themedColor: ColorResource
  get() = CommonMainColors0.themedColor

public actual val SharedRes.colors.themedReferenceColor: ColorResource
  get() = CommonMainColors0.themedReferenceColor

public actual val SharedRes.colors.transparent: ColorResource
  get() = CommonMainColors0.transparent

public actual val SharedRes.colors.transparent_orange4: ColorResource
  get() = CommonMainColors0.transparent_orange4

public actual val SharedRes.colors.transparent_orange5: ColorResource
  get() = CommonMainColors0.transparent_orange5

public actual val SharedRes.colors.valueColor: ColorResource
  get() = CommonMainColors0.valueColor
